import { post } from 'api/axiosApi';
import { env } from 'utils/env';

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

export function updateOfferAssociatedPartnerConsents(data) {
  return post(url + `/leasingoffers/${data.documentId}/${data.siteId}/associatedpartner/${data.partnerId}/consents`, data);
}

export function updateOfferAssociatedPartnerConsent(data) {
  return post(url + `/leasingoffers/${data.documentId}/${data.siteId}/associatedpartner/${data.partnerId}/consent`, data);
}
